export default __webpack_public_path__ + "static/media/Desktop-Logbook-OpsDashboard-600.3a2df8d1.png";